module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    staticClass: "searchbar-found",
    attrs: {
      "media-list": "",
      "id": "group-list"
    }
  }, _vm._l((_vm.contactGroups), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "showLargeScreenOnly"
    }, _vm._l((group), function(contactGroup) {
      return _c('li', {
        key: contactGroup.id,
        staticClass: "boxRequest",
        attrs: {
          "media": '<div class=\'manualChip\'>' + contactGroup.label[0] + '</div>'
        },
        on: {
          "click": function($event) {
            return _vm.editContactGroup(contactGroup)
          }
        }
      }, [_c('div', {
        staticClass: "item-content boxRequest"
      }, [_c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contactGroup.label))])]), _vm._v(" "), _c('div', {
        staticClass: "item-media"
      }, [_c('button', {
        staticClass: "button-swipe-out",
        on: {
          "click": function($event) {
            return _vm.removeContactGroup(contactGroup)
          }
        }
      }, [_c('f7-icon', {
        staticClass: "button-delete",
        attrs: {
          "f7": "close_round"
        }
      })], 1)])])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly"
    }, _vm._l((group), function(contactGroup) {
      return _c('f7-list-item', {
        key: contactGroup.id,
        staticClass: "boxRequest",
        attrs: {
          "swipeout": "",
          "title": contactGroup.label,
          "media": '<div class=\'manualChip\'>' + contactGroup.label[0] + '</div>'
        },
        on: {
          "swipeout:deleted": function($event) {
            return _vm.removeContactGroup(contactGroup)
          },
          "click": function($event) {
            return _vm.editContactGroup(contactGroup)
          }
        }
      }, [_c('f7-swipeout-actions', [_c('f7-swipeout-button', {
        staticClass: "swipeout-create",
        attrs: {
          "href": "/account/editContactGroup/"
        }
      }, [_vm._v("Edit")]), _vm._v(" "), _c('f7-swipeout-button', {
        attrs: {
          "data-confirm": _vm.$i18n.t('contacts.group_deletion_confirm'),
          "data-confirm-title": _vm.$i18n.t('common.rm_as_question'),
          "data-close-on-cancel": "true",
          "delete": ""
        }
      }, [_vm._v(_vm._s(_vm.$t('common.rm_label')))])], 1)], 1)
    }), 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19e4f26b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19e4f26b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactsPage/CMContactGroupList.vue
// module id = 2301
// module chunks = 2